// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".is-divider[data-v-327cd2c2] {\n  margin: 1.2em 0;\n}\n.short-width[data-v-327cd2c2] {\n  width: 10%;\n}\n.desc-width[data-v-327cd2c2] {\n  width: 60%;\n}", ""]);
// Exports
module.exports = exports;
